import Parameter from '../../Parameter';
import processParameters from '../../FormModel/utils/processParameters';

/** utility fn to create
 *
 * - a mapping of { [navGroup]: IParameterProperty[] }
 * - 'order' array representing the appearance (hence order) of navGroups
 */
const getNavGroupsAndOrder = params => {
  const order = [];
  const navGroups = {};
  params.forEach(parameter => {
    if (parameter.navGroup) {
      const group = navGroups[parameter.navGroup] || [];
      group.push(parameter);
      if (!order.includes(parameter.navGroup)) {
        order.push(parameter.navGroup);
      }
      navGroups[parameter.navGroup] = group;
    }
  });
  return [navGroups, order];
};

export default class FieldSet extends Parameter {
  constructor(parameter) {
    super(parameter);
    this.params = processParameters(parameter.params, this.broadcast.bind(this));
    [this._navGroups, this._order] = getNavGroupsAndOrder(parameter.params);

    this.onChange = this.onChange.bind(this);
  }

  onChange(name, value) {
    this.params[name].value = value;
  }

  valueChanged() {
    return Object.keys(this.params).filter(key => this.params[key].valueChanged()).length > 0;
  }

  get navGroups() {
    return this._navGroups;
  }

  get order() {
    return this._order;
  }

  getPayloadValue() {
    const payload = Object.keys(this.params).map(key => {
      return this.params[key].getPayloadValue();
    });

    return payload;
  }
}
